export const queryKeys = {
  dashboardSuper: () => ['dashboard', 'super'],
  dashboardOwner: (fisherId) => ['dashboard', 'owner', fisherId],
  dashboardStaff: () => ['dashboard', 'staff'],
  dashboardSampledFishSummary: (fisherId) => ['dashboard', 'sampledFishSummary', fisherId],
  dashboardOwnerFishTypes: (fisherId) => ['dashboard', 'ownerFishTypes', fisherId],
  dashboardSamplingEvents: (fisherId) => ['dashboard', 'samplingEvents', fisherId],
  fishTypes: (params = {}) => ['fishTypes', params],
  lengthUnits: (params = {}) => ['lengthUnits', params],
  weightUnits: (params = {}) => ['weightUnits', params],
  ponds: (scope) => ['ponds', scope],
  pond: (pondId) => ['pond', pondId],
  fishTypesList: (params = {}) => ['fishTypesList', params],
  samplingEnrich: (key = {}) => ['samplingEnrich', key],
};
